import React__default from 'react';

/**
 * Render the grid of days for a specific month.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function MonthGrid(props) {
    return React__default.createElement("table", { ...props });
}

export { MonthGrid };
